package com.shadowings.gero.presentation.component

import com.shadowings.gero.presentation.util.DevicePreviews
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.ui.hieroglyphTint
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.U28
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun TopBarTag(
    modifier: Modifier = Modifier,
    image: DrawableResource,
    description: String,
    count: Int,
    iconSize: Dp = 24.dp,
    showLabel: Boolean = false,
    showBadge: Boolean = false
) {
    Box(
        modifier.padding(vertical = 8.dp)
    ) {
        Row(
            modifier = Modifier
                .heightIn(min = 36.dp)
                .fillMaxWidth()
                .padding(vertical = 2.dp, horizontal = 4.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = if (showLabel) Arrangement.spacedBy(8.dp) else Arrangement.Center
        ) {
            Image(
                modifier = Modifier
                    .size(iconSize)
                    .padding(vertical = 2.dp),
                painter = painterResource(image),
                contentDescription = description,
                colorFilter = ColorFilter.tint(hieroglyphTint)
            )
            if (showLabel) {
                Text(description, modifier = Modifier.weight(1f))
            }
            val countText = @Composable { Text(" $count") }
            if (showBadge) {
                BadgedBox(badge = { Badge() }) {
                    countText()
                }
            } else {
                countText()
            }
        }
    }
}

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun TopBarTagPreview() {
    AppTheme {
        Surface {
            TopBarTag(
                image = Res.drawable.U28,
                description = "Fire Count",
                count = 12
            )
        }
    }
}
